import { HS_NAV_BEFORE_CONTAINER_ID, GROWTH_DYNAMIC_UI_ID, NOTIFICATIONS_BANNER_IFRAME_ID, ONBOARDING_TOURS_BANNER_ID, TRIAL_BANNER_ID } from '../constants';
import { getContainersAboveNav } from './getContainersAboveNav';
export function setNavPositions() {
  const hasStickyToolbar = document.body.classList.contains('sticky-global-toolbar');
  if (!hasStickyToolbar) {
    return;
  }
  const containersAboveNav = getContainersAboveNav();
  setStickyToolbarAndBannerPositions(containersAboveNav);
}
function setStickyToolbarAndBannerPositions(containers) {
  let totalHeight = 0;
  Object.entries(containers).forEach(([containerId, container]) => {
    const containerHeight = container ? container.getBoundingClientRect().height : 0;
    totalHeight += containerHeight;
    let trialBannerContainer = null;
    if (containerId === HS_NAV_BEFORE_CONTAINER_ID) {
      setBodyStyleVariable('--global-nav-sticky-nav-before-container-top', 0);
    } else if (containerId === TRIAL_BANNER_ID || containerId === GROWTH_DYNAMIC_UI_ID) {
      trialBannerContainer = containers[TRIAL_BANNER_ID] || containers[GROWTH_DYNAMIC_UI_ID];
      setBodyStyleVariable('--global-nav-sticky-trial-banner-top', getContainerBottom(trialBannerContainer));
    } else if (containerId === NOTIFICATIONS_BANNER_IFRAME_ID) {
      setBodyStyleVariable('--global-nav-notifications-banner-iframe-top', getContainerBottom(trialBannerContainer));
    } else if (containerId === ONBOARDING_TOURS_BANNER_ID) {
      setBodyStyleVariable('--global-nav-onboarding-tours-banner-top', getContainerBottom(containers[NOTIFICATIONS_BANNER_IFRAME_ID]));
    }
  });
  setBodyStyleVariable('--global-nav-sticky-nav-top', totalHeight);
  function setBodyStyleVariable(variable, value) {
    document.body.style.setProperty(variable, `${value}px`);
  }
  function getContainerBottom(container) {
    return container ? container.getBoundingClientRect().bottom : 0;
  }
}